const customForm = document.querySelector('.custom-tailor').innerHTML;
document.addEventListener('variant:change', function(event) {
    var variant = event.detail.variant;
    if (variant.title.includes("Custom")) {
        document.querySelector('.custom-tailor').innerHTML = customForm;
        document.querySelector('.custom-tailor').style.display = 'block';
    }
    else {
        document.querySelector('.custom-tailor').innerHTML = '';
        document.querySelector('.custom-tailor').style.display = 'none';
    }
});